import { FormInput } from "@general-backoffice/core";
import type { TaxProfile } from "@investhinks/api-client";
import React from "react";
import { Card, CardBody } from "reactstrap";

type AgreementStepTaxProfile = Pick<TaxProfile, "autofacturaAgreement"> & Record<string, unknown>;

interface AgreementStepProps {
  taxProfile: AgreementStepTaxProfile | null;
  handleInputChange: (name: string, value: unknown) => void;
  isLoading: boolean;
  t: (key: string, fallback?: string) => string;
}

const AgreementStep = ({ taxProfile, handleInputChange, isLoading, t }: AgreementStepProps) => (
  <div>
    <h5 className="mb-3">{t("steps.agreement.title", "Autofactura Agreement")}</h5>
    <p className="text-muted mb-4">
      {t("steps.agreement.description", "Please review and accept the self-billing (autofactura) agreement.")}
    </p>

    <Card className="bg-light">
      <CardBody>
        <h6>{t("steps.agreement.legalTitle", "Self-Billing Agreement")}</h6>
        <p className="small">
          {t(
            "steps.agreement.legalText",
            "In accordance with Article 5 of Royal Decree 1619/2012, I authorize the recipient of my services to issue invoices on my behalf (self-billing / autofactura). I confirm that I will not issue separate invoices for the same transactions."
          )}
        </p>
        <hr />
        <FormInput.Switch
          label={t("steps.agreement.checkbox", "I accept the self-billing agreement")}
          name="autofacturaAgreement"
          checked={taxProfile?.autofacturaAgreement || false}
          onChange={(e) => handleInputChange("autofacturaAgreement", e.target.checked)}
          disabled={isLoading}
        />
      </CardBody>
    </Card>
  </div>
);

export default AgreementStep;
